'use client';

import cn from 'classnames';
import NextImage from 'next/image';
import { useParams } from 'next/navigation';
import { useCallback, useEffect, useMemo } from 'react';
import Svg from 'react-inlinesvg';
import style from './FlatFloorsScheme.module.scss';
const FlatFloorsScheme = ({
  floorNumber,
  image,
  flatBulk,
  flat,
  flatNumber,
  svg
}) => {
  const params = useParams();
  const apartmentId = params.flatId;
  const buildingPhase = flat?.bulk?.buildingPhase;
  const views_10100 = useMemo(() => `/plans/views/views_10100.svg`, []);
  const views_other = useMemo(() => `/plans/views/views_other.svg`, []);
  const viewsSvg = flatBulk === 10100 ? views_10100 : views_other;
  const beforeSvgInjection = useCallback(() => {
    if (document.querySelector(`#floor-svg`)) {
      const genplanElements = Array.from(document.querySelector(`#flats`)?.childNodes);
      const svg_0 = document.querySelector(`#floor-svg`);
      if (svg_0 && buildingPhase !== 1) {
        svg_0.classList.add(style.secondQueue);
      }
      const flats = genplanElements.filter(item => item.id.includes('fl')).filter(elem => !elem.id.includes('flats'));
      flats.forEach(item_0 => {
        const id = item_0.id.replace('fl', '');
        if (Number(id) === Number(apartmentId) || Number(id) === Number(flatNumber)) {
          item_0.classList.add(`floor__active`);
        } else {
          item_0.classList.add(`floor__reserve`);
        }
      });
    }
  }, [apartmentId]);
  useEffect(() => {
    beforeSvgInjection();
  }, [floorNumber, flatBulk, beforeSvgInjection]);
  return <div className={style.flatFloorsScheme}>
      <NextImage fill className={cn(buildingPhase !== 2 ? style.flatFloorsScheme__flat : style.flatFloorsScheme__flat_alt, style.objectFitContain)} src={image} alt='icon-flat' sizes='100vw' priority unoptimized={true} />
      <Svg src={svg} className={style.flatFloorsScheme__svg} onLoad={() => beforeSvgInjection()} id='floor-svg' preserveAspectRatio='xMidYMid slice' />
      <Svg src={viewsSvg} className={style.flatFloorsScheme__path_svg} alt='Описания видов из окон' />
    </div>;
};
export default FlatFloorsScheme;